module.exports = __webpack_public_path__ + "static/media/online-back-vid.ca0e6f43.mp4";